import React from "react";
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonInput,
  IonTextarea,
  IonLoading,
} from "@ionic/react";

type Props = {
  isOpen: boolean;
  onDidDismiss: () => void;

  editingCrewId: string | null;

  newCrewName: string;
  setNewCrewName: (v: string) => void;

  newCrewDescription: string;
  setNewCrewDescription: (v: string) => void;

  onSave: () => void;

  savingCrew: boolean;
};

export const CreateCrewModal: React.FC<Props> = ({
  isOpen,
  onDidDismiss,
  editingCrewId,
  newCrewName,
  setNewCrewName,
  newCrewDescription,
  setNewCrewDescription,
  onSave,
  savingCrew,
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
    >
      <IonHeader
      >
        <IonToolbar
        >
          <IonTitle
          >
            {editingCrewId ? "Edit Crew Details" : "Create Crew"}
          </IonTitle>

          <IonButtons
            slot="end"
          >
            <IonButton
              onClick={onDidDismiss}
            >
              Cancel
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent
      >
        <div style={{ padding: "14px" }}>
          <IonItem
            lines="full"
          >
            <IonLabel
              position="stacked"
            >
              Crew Name
            </IonLabel>
            <IonInput
              value={newCrewName}
              onIonChange={(e) => setNewCrewName(e.detail.value || "")}
              placeholder="e.g., Night Detail"
            />
          </IonItem>

          <IonItem
            lines="full"
            style={{ marginTop: "10px" }}
          >
            <IonLabel
              position="stacked"
            >
              Description (optional)
            </IonLabel>
            <IonTextarea
              value={newCrewDescription}
              onIonChange={(e) => setNewCrewDescription(e.detail.value || "")}
              autoGrow={true}
              placeholder="Short description..."
            />
          </IonItem>

          <div style={{ marginTop: "14px" }}>
            <IonButton
              color="secondWarning"
              expand="block"
              onClick={onSave}
              disabled={savingCrew}
            >
              Save
            </IonButton>
          </div>
        </div>

        <IonLoading isOpen={savingCrew} message="Saving..." />
      </IonContent>
    </IonModal>
  );
};
